import _classCallCheck from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/renovation/ui/scroll_view/utils/scroll_direction.js)
 * Version: 21.2.4
 * Build date: Mon Dec 06 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { DIRECTION_VERTICAL, DIRECTION_HORIZONTAL, DIRECTION_BOTH } from "../common/consts";
export var ScrollDirection = /*#__PURE__*/function () {
  function ScrollDirection(direction) {
    _classCallCheck(this, ScrollDirection);

    this.DIRECTION_HORIZONTAL = "horizontal";
    this.DIRECTION_VERTICAL = "vertical";
    this.DIRECTION_BOTH = "both";
    this.direction = null !== direction && void 0 !== direction ? direction : DIRECTION_VERTICAL;
  }

  _createClass(ScrollDirection, [{
    key: "isHorizontal",
    get: function get() {
      return this.direction === DIRECTION_HORIZONTAL || this.direction === DIRECTION_BOTH;
    }
  }, {
    key: "isVertical",
    get: function get() {
      return this.direction === DIRECTION_VERTICAL || this.direction === DIRECTION_BOTH;
    }
  }, {
    key: "isBoth",
    get: function get() {
      return this.direction === DIRECTION_BOTH;
    }
  }]);

  return ScrollDirection;
}();